(function () {
  "use strict";

  var section = document.querySelector('[data-section-type="page-search"]');
  if (!section) return;

  var params = new URLSearchParams(window.location.search);
  var rawQuery = String(params.get("rehair_q") || params.get("q") || "").trim();
  if (!rawQuery) return;

  var variantWords = new Set([
    "black", "blonde", "brown", "chestnut", "cool", "dark", "darkest", "gray", "grey",
    "jet", "light", "lightest", "medium", "off", "percent", "percentage"
  ]);
  var stopWords = new Set(["a", "an", "and", "for", "of", "or", "the", "to", "with"]);

  function normalize(value) {
    return String(value || "")
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/(\d)\s*["”]?\s*x\s*(\d)/g, "$1x$2")
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function tokensFor(value) {
    return normalize(value).split(" ").filter(function (token) {
      return token && !stopWords.has(token);
    });
  }

  function titleTokensFor(value) {
    return tokensFor(value).filter(function (token) {
      if (variantWords.has(token)) return false;
      if (/^\d+(?:x\d+)?$/.test(token)) return false;
      if (/^\d+[a-z]\d*$/.test(token)) return false;
      return token.length >= 3;
    }).slice(0, 4);
  }

  function structuredQueryFor(value) {
    return titleTokensFor(value).map(function (token) {
      return "title:" + token;
    }).join(" ");
  }

  function redirectToStructuredSearch(value) {
    if (params.has("rehair_q") || /^title:/i.test(value)) return false;
    var structured = structuredQueryFor(value);
    if (!structured) return false;

    params.set("q", structured);
    params.set("rehair_q", value);
    params.set("type", "product");
    params.set("options[prefix]", "none");
    window.location.replace(window.location.pathname + "?" + params.toString());
    return true;
  }

  if (redirectToStructuredSearch(rawQuery)) return;

  // 2026-10-13: the strict title search has no typo or prefix tolerance ("toupe" found nothing while Shopify's
  // own search finds hundreds). When it comes back empty, repeat the search once with the plain query.
  var isFallback = params.get("rehair_fb") === "1";
  var queryTokens = tokensFor(rawQuery);
  var resultNodes = Array.prototype.slice.call(section.querySelectorAll("[data-rehair-search-result]"));
  var visibleCount = 0;

  resultNodes.forEach(function (node) {
    var haystack = normalize(node.getAttribute("data-rehair-search-haystack"));
    var matches = isFallback || queryTokens.every(function (token) {
      return haystack.indexOf(token) !== -1;
    });
    node.hidden = !matches;
    if (matches) visibleCount += 1;
  });

  if (!isFallback && visibleCount === 0) {
    var fallback = new URLSearchParams();
    fallback.set("q", rawQuery);
    fallback.set("type", "product");
    fallback.set("options[prefix]", "last");
    fallback.set("rehair_q", rawQuery);
    fallback.set("rehair_fb", "1");
    window.location.replace(window.location.pathname + "?" + fallback.toString());
    return;
  }

  var heading = section.querySelector("[data-rehair-search-heading]");
  if (heading && !isFallback) {
    var headingTemplate = heading.getAttribute("data-rehair-search-heading-template") || "Found 999 results for \"__TERMS__\"";
    heading.textContent = headingTemplate.replace("999", String(visibleCount)).replace("__TERMS__", rawQuery);
    document.title = document.title
      .replace(/\d+ results found/i, visibleCount + " results found")
      .replace(/for [“\"&quot;].*?[”\"](?=\s*[–-])/i, 'for "' + rawQuery + '"');
  }

  var searchInput = section.querySelector('input[name="q"]');
  if (searchInput) searchInput.value = rawQuery;

  var emptyState = section.querySelector("[data-rehair-search-empty]");
  if (emptyState) emptyState.hidden = visibleCount !== 0;

  if (visibleCount === 0) {
    Array.prototype.forEach.call(
      section.querySelectorAll(".m-sidebar, .m-collection-page-toolbar, .m-search-pagination, .m-search-result"),
      function (node) { node.hidden = true; }
    );
  }

  section.addEventListener("submit", function (event) {
    var form = event.target;
    var input = form && form.querySelector ? form.querySelector('input[name="q"]') : null;
    if (!input || !input.value.trim()) return;

    var value = input.value.trim();
    var structured = structuredQueryFor(value);
    if (!structured) return;

    event.preventDefault();
    var next = new URL(form.action || window.location.pathname, window.location.origin);
    next.searchParams.set("q", structured);
    next.searchParams.set("rehair_q", value);
    next.searchParams.set("type", "product");
    next.searchParams.set("options[prefix]", "none");
    window.location.assign(next.pathname + "?" + next.searchParams.toString());
  });
})();
